<template lang="pug">
span {{ name || '' }}
</template>

<script>
/* eslint-disable camelcase */
export default {
  name: 'ProjectName',
  props: {
    projectId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      name: '',
    };
  },
  watch: {
    projectId() {
      this.loadData();
    },
  },
  computed: {},
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      if (!this.projectId) return;
      const res = await this.api(`/api/projects/name/${this.projectId}`)();
      const { title = '' } = res || {};
      this.name = title;
    },
  },
};
</script>

<style lang="scss" scoped></style>
